var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandingWatermark1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90599 8.62526H10.2185C10.3955 8.62526 10.5492 8.56001 10.6797 8.42951C10.8097 8.29951 10.8747 8.14601 10.8747 7.96901V5.56226C10.8747 5.38526 10.8097 5.23176 10.6797 5.10176C10.5492 4.97126 10.3955 4.90601 10.2185 4.90601H5.90599C5.72899 4.90601 5.57549 4.97126 5.44549 5.10176C5.31499 5.23176 5.24974 5.38526 5.24974 5.56226V7.96901C5.24974 8.14601 5.31499 8.29951 5.44549 8.42951C5.57549 8.56001 5.72899 8.62526 5.90599 8.62526ZM1.56274 10.5003C1.19824 10.5003 0.888244 10.3725 0.632744 10.117C0.377744 9.86201 0.250244 9.55226 0.250244 9.18776V1.81226C0.250244 1.44776 0.377744 1.13801 0.632744 0.883006C0.888244 0.627506 1.19824 0.499756 1.56274 0.499756H11.4372C11.8017 0.499756 12.1117 0.627506 12.3672 0.883006C12.6222 1.13801 12.7497 1.44776 12.7497 1.81226V9.18776C12.7497 9.55226 12.6222 9.86201 12.3672 10.117C12.1117 10.3725 11.8017 10.5003 11.4372 10.5003H1.56274ZM1.56274 9.18776H11.4372V1.81226H1.56274V9.18776Z",
    fill: "#72777F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingWatermark1);
export default __webpack_public_path__ + "static/media/branding_watermark1.3f4c3ea4a968c6142630e64115ebcb88.svg";
export { ForwardRef as ReactComponent };